import React, { useState } from "react";
import { WhatsappLogo, Spinner } from "@phosphor-icons/react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SharePricesButton = () => {
  const [busy, setBusy] = useState(false);

  const share = async () => {
    setBusy(true);
    try {
      const res = await fetch(`${API}/share/price-card`);
      if (!res.ok) throw new Error("card failed");
      const blob = await res.blob();
      const file = new File([blob], "farmwatch-weekly-prices.png", { type: "image/png" });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: "This week's farm prices",
          text: "This week's official farm prices — via farmwatch.com",
        });
      } else {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "farmwatch-weekly-prices.png";
        a.click();
        URL.revokeObjectURL(url);
        window.open(`https://wa.me/?text=${encodeURIComponent("This week's official farm prices \u2014 https://www.farmwatch.com")}`, "_blank");
        toast.success("Price card downloaded — attach it to your WhatsApp message");
      }
    } catch (e) {
      if (e.name !== "AbortError") toast.error("Could not create the price card");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button onClick={share} disabled={busy} data-testid="share-prices-btn"
      className="inline-flex items-center gap-2 px-4 py-2 bg-[#25D366] text-white text-sm font-semibold hover:bg-[#1DA851] transition-colors disabled:opacity-60">
      {busy ? <Spinner size={16} className="animate-spin" /> : <WhatsappLogo size={16} weight="fill" />}
      {busy ? "Preparing card..." : "Share this week's prices"}
    </button>
  );
};

export default SharePricesButton;
